<!-- role/aria-live no container, não em cada toast: o leitor anuncia a região uma vez. -->
<div class="notifications-toaster" role="status" aria-live="polite" data-cy="notifications-toaster">
  @for (toast of viewToasts(); track toast.id) {
    <lkt-notification-toast
      [item]="toast"
      [animate]="animate()"
      [dataCy]="toastDataCy(toast.id)"
      [class.is-entering]="isEntering(toast.id)"
      [class.is-leaving]="isLeaving(toast.id)"
      (expired)="onExpired(toast.id)"
      (closeToast)="onCloseToast(toast.id)"
      (ctaSelect)="onCtaSelect(toast.id)" />
  }
</div>
